import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility';

const initialState = {
	data: null,
};

const getPushNotificationsTypes = (state, action) => {
	return updateObject(state, { data: action.data });
};

const types = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_PUSH_NOTIFICATIONS_TYPES_SUCCESS:
			return getPushNotificationsTypes(state, action);

		default:
			return state;
	}
};

export default types;
